// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCommentsByWorkItemIdRequestModel from '../../model/get-comments-by-work-item-id-request-model';
import GetCommentsByWorkItemIdRequestDTO from '../dto/get-comments-by-work-item-id-request-dto';
import dtoSchema from '../schemas/get-comments-by-work-item-id-request-schema';

export default abstract class GetCommentsByWorkItemIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCommentsByWorkItemIdRequestDTO>) {
    super();
    if (data) {
      this.projectId = data.projectId;
      this.workItemId = data.workItemId;
    }
  }
  /**
  * @type {uuid}
  */
  projectId?: string;
  /**
  * @type {int32}
  */
  workItemId?: number;

  static toModel(dto: DeepPartial<GetCommentsByWorkItemIdRequestDTO>): GetCommentsByWorkItemIdRequestModel;
  static toModel(dto: DeepPartial<GetCommentsByWorkItemIdRequestDTO> | undefined | null): GetCommentsByWorkItemIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCommentsByWorkItemIdRequestDTO> | undefined | null): GetCommentsByWorkItemIdRequestModel | undefined {
    return dto ? new GetCommentsByWorkItemIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCommentsByWorkItemIdRequestModel> | GetCommentsByWorkItemIdRequestModel): GetCommentsByWorkItemIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      projectId: unwrapped.projectId,
      workItemId: unwrapped.workItemId,
    } as GetCommentsByWorkItemIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetCommentsByWorkItemIdRequestModel, can not map to GetCommentsByWorkItemIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
